import { createFileRoute } from "@tanstack/react-router";

import { adminOrganizationListQuerySchema } from "@kansai-ai-hub/schema";

import { AdminMembersPage } from "@/features/admin/organizations-page";
import { adminOrganizationListQueryOptions } from "@/features/admin/queries";

const membersSearchSchema = adminOrganizationListQuerySchema.omit({ role: true });

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/organizations/members")({
  validateSearch: membersSearchSchema,
  loaderDeps: ({ search }) => ({ ...search, role: "MEMBER" as const }),
  loader: async ({ context, deps }) => {
    await context.queryClient.ensureQueryData(adminOrganizationListQueryOptions(deps));
  },
  component: AdminMembersPage,
});
